import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableSortLabel,
} from '@mui/material';
import PropTypes from 'prop-types';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import LinkIcon from '@mui/icons-material/Link';
import { Link, useNavigate } from 'react-router-dom';

function DeviceManagerTable({ records, onDelete }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [orderDirection, setOrderDirection] = useState('asc');
  const [orderBy, setOrderBy] = useState('residentName');
  const navigate = useNavigate();

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && orderDirection === 'asc';
    setOrderDirection(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedRecords = () => {
    return records.sort((a, b) => {
      let aValue = a[orderBy];
      let bValue = b[orderBy];

      if (aValue < bValue) {
        return orderDirection === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return orderDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="devices table">
        <TableHead>
          <TableRow>
            <TableCell key="edit"></TableCell>

            <TableCell key="link">Link</TableCell>

            <TableCell key="deviceId">
              <TableSortLabel
                active={orderBy === 'deviceId'}
                direction={orderBy === 'deviceId' ? orderDirection : 'asc'}
                onClick={() => handleRequestSort('deviceId')}
              >
                Device ID
              </TableSortLabel>
            </TableCell>

            <TableCell key="residentName">
              <TableSortLabel
                active={orderBy === 'residentName'}
                direction={orderBy === 'residentName' ? orderDirection : 'asc'}
                onClick={() => handleRequestSort('residentName')}
              >
                Resident
              </TableSortLabel>
            </TableCell>

            <TableCell key="roomName">
              <TableSortLabel
                active={orderBy === 'roomName'}
                direction={orderBy === 'roomName' ? orderDirection : 'asc'}
                onClick={() => handleRequestSort('roomName')}
              >
                Room
              </TableSortLabel>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRecords()
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((record) => {
              return (
                <TableRow key={record.id}>
                  <TableCell>
                    <div style={{ display: 'inline-flex' }}>
                      <DeleteForeverIcon
                        onClick={() => onDelete(record)}
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                  </TableCell>
                  <TableCell>
                    <div>
                      <Link
                        to={`/slideshow?deviceId=${record.deviceId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: 'inherit', textDecoration: 'none' }}
                      >
                        <LinkIcon style={{ cursor: 'pointer' }} />
                      </Link>
                    </div>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {record.deviceId}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {record.residentName}
                  </TableCell>

                  <TableCell component="th" scope="row">
                    {record.roomName}
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={records.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}

DeviceManagerTable.propTypes = {
  records: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      deviceId: PropTypes.string.isRequired,
      residentName: PropTypes.string.isRequired,
      roomName: PropTypes.string,
    }),
  ).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeviceManagerTable;
